import { actions } from '../../utils/constants';

export const asyncUpdateQuestion = ({
    questionId,
    question,
    options,
    enabled,
}) => ({
    type: actions.ASYNC_UPDATE_QUESTION,
    payload: { questionId, question, options, enabled },
});

export const fetchAsyncQuestionToManage = questionId => ({
    type: actions.ASYNC_FETCH_QUESTION_TO_MANAGE,
    payload: { questionId },
});

export const changeQuestionToManage = payload => ({
    type: actions.CHANGE_QUESTION_TO_MANAGE,
    payload: payload,
});



// WEBPACK FOOTER //
// ./src/components/manage-question/manage-question.actions.js